import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {toast} from 'sonner';
import api from '@/lib/api';
import {useAuth} from '@/context/AuthContext';

export default function LightspeedCheckButton({hostname}){
 const [busy,setBusy]=useState(false);const navigate=useNavigate();const {canWrite}=useAuth();
 const check=async()=>{setBusy(true);try{const row=await api.post('/lightspeed/checks',{hostnames:[hostname]});navigate('/lightspeed?batch='+row.id);}catch(e){toast.error(e?.response?.data?.detail||'Lightspeed check failed; no filtering decision was made');}finally{setBusy(false);}};
 return <button type="button" className="inline-flex items-center justify-center border border-zinc-700 rounded-md px-3 py-2 text-xs text-sky-300 hover:bg-zinc-800 disabled:opacity-40 ml-2" aria-label={'Check Lightspeed for '+hostname} disabled={busy||!canWrite} onClick={check}>{busy?'Checking…':'Check Lightspeed'}</button>;
}
